// The link that opens Pinterest's "create a Pin" window with the design's photo, its page
// address and a description already filled in — the person only picks a board and saves.
// The Pin links back to the design's page on GatherYou.

const DESCRIPTION_MAX = 450;

export function pinterestPinUrl(design) {
  const image = (design.images && design.images[0]) || design.image_url;
  if (!image) return null;

  const caption = (design.title || "").replace(/\s+/g, " ").trim();
  const description = !caption
    ? "Punjabi embroidery design on GatherYou"
    : caption.length > DESCRIPTION_MAX
      ? `${caption.slice(0, DESCRIPTION_MAX - 1).trimEnd()}…`
      : caption;

  const params = new URLSearchParams({
    url: `${window.location.origin}/d/${design.id}`,
    media: image,
    description
  });
  return `https://www.pinterest.com/pin/create/button/?${params.toString()}`;
}

export function openPinterestPin(design) {
  const url = pinterestPinUrl(design);
  if (url) window.open(url, "_blank", "noopener,noreferrer");
}
